import { useTranslation } from 'react-i18next';

import { DealDatePickerCell, useUpdatePostponedDealMutation } from '@crm/entities/deal';

import type { TDeal } from '@crm/entities/deal';

type PostponedUntilCellProps = {
    dealId: TDeal['id'];
    postponedUntil: string;
};

export const PostponedUntilCell = ({ dealId, postponedUntil }: PostponedUntilCellProps) => {
    const { t } = useTranslation();
    const { mutate: updatePostponedDeal, isPending } = useUpdatePostponedDealMutation({ dealId });

    const onUpdateDealDate = (date?: string) => {
        updatePostponedDeal({ postponedUntil: date ?? null });
    };

    return (
        <DealDatePickerCell
            date={postponedUntil}
            isPending={isPending}
            changeDateAriaLabel={t('crm.common.dealsTable.cells.nextContact.changeDateAriaLabel')}
            clearDateAriaLabel={t('crm.common.dealsTable.cells.nextContact.clearDateAriaLabel')}
            onChange={onUpdateDealDate}
        />
    );
};
